// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"0218f31f","693":"0218f31f"}[chunkId] + ".chunk.css";
};